<script lang="ts">
	import { getContext } from "svelte";
	import type { User } from "#gen/identities/v1/identities_pb.js";
	import { formatTimestampAsDate } from "#lib/timestamp.js";
	import type { Timestamp } from "@bufbuild/protobuf/wkt";
	import type { Writable } from "svelte/store";

	interface Props {
		timestamp?: Timestamp;
	}

	const user: Writable<User> = getContext("user");

	let { timestamp }: Props = $props();
</script>

{formatTimestampAsDate(timestamp, $user.timezone)}
